import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      showPassword: false,
      showOldPassword: false,
      showConfirmPassword: false,
      formValid: false,
      formData: {
        password: '',
        old_password: '',
        confirm_password: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      loading: 'themes/player/loading'
    }),
    formRule() {
      return {
        password: [
          v => !!v || this.tr(this.FRONTEND_ERROR_CODES.passwordIsRequired),
          v => (v && v.length >= 6) || this.tr(this.FRONTEND_ERROR_CODES.passwordGreaterThan6)
        ],
        old_password: [
          v => !!v || this.tr(this.FRONTEND_ERROR_CODES.oldPasswordIsRequired),
          v => (v && v.length >= 6) || this.tr(this.FRONTEND_ERROR_CODES.passwordGreaterThan6)
        ],
        confirm_password:
          this.formData.password && this.formData.confirm_password
            ? [
                v =>
                  this.formData.password === v ||
                  this.tr(this.FRONTEND_ERROR_CODES.passwordNotMatch)
              ]
            : [
                v => !!v || this.tr(this.FRONTEND_ERROR_CODES.confirmPasswordIsRequired),
                v => (v && v.length >= 6) || this.tr(this.FRONTEND_ERROR_CODES.passwordGreaterThan6)
              ]
      }
    }
  },
  methods: {
    async changePassword() {
      await this.$refs?.refPassword?.validate()
      if (this.formValid) {
        const result = await this.$store.dispatch('themes/player/doResetPassword', {
          ...this.formData
        })
        if (result) {
          this.$refs?.refPassword?.reset()
          if (this.value) {
            this.$emit('input', false)
          }

          // force logout
          this.logout();
        }
      }
    },
    resetForm() {
      this.$refs?.refPassword?.reset()
    }
  }
}
